import React from "react";
import { Input, Row, Typography, Form, Card, Col } from "antd";
import appLabel from "../../../../../config/appLabel";

const { Text } = Typography;

export default function TermsForm({ casaDetail }) {
  const [useForm] = Form.useForm();

  console.log(casaDetail);
  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.norminalAnnualInterest}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail.nominalAnnualInterestRate}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.interestCompoundingPeriod}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.interestCompoundingPeriodType?.value}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.interestPostingPeriod}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.interestPostingPeriodType?.value}
              ></Input>
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{"Forfeit Interest for Withdrawals"}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.forfeitInterest === false ? "No" : "Yes"}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{"Number of Withdrawals Threshold"}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.maxAllowedWithdrawalCount}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.interestCalculatedUsing}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.interestCalculationType?.value}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>{appLabel.daysInYear}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={casaDetail?.interestCalculationDaysInYearType?.value}
              />
            </Form.Item>
          </Col>
          <div style={{ width: "30vh" }}></div>
        </Row>
      </Card>
    </Form>
  );
}
